"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_edit_text_1 = require("react-edit-text");
var PropTypes = __importStar(require("prop-types"));
// Local imports
var Icon_1 = require("../Icon");
var ListToggle_1 = require("../ListToggle");
var Panel_1 = require("../Panel");
var PanelCell_1 = require("../PanelCell");
var propTypes = {
    label: PropTypes.string.isRequired,
    onDelete: PropTypes.func.isRequired,
    onLabelChange: PropTypes.func.isRequired,
    onLabelBlur: PropTypes.func,
    children: PropTypes.node.isRequired,
};
var ExpandableGroup = function (_a) {
    var label = _a.label, onDelete = _a.onDelete, onLabelChange = _a.onLabelChange, onLabelBlur = _a.onLabelBlur, children = _a.children;
    var _b = React.useState(false), expanded = _b[0], setExpanded = _b[1];
    var _c = React.useState(false), error = _c[0], setError = _c[1];
    React.useEffect(function () {
        if (label.length > 0) {
            setError(false);
        }
    }, [label]);
    var styles = {
        marginLeft: 10,
        paddingLeft: 4,
        width: '314px',
        height: '29px',
        background: '#FFFFFF',
        borderRadius: '5px',
        border: '1px solid inherit',
    };
    if (error) {
        styles = __assign(__assign({}, styles), { border: '1px solid red' });
    }
    return (React.createElement(Panel_1.Panel, { mods: (error ? 'u-padBottomSm' : '') + " expandable-group" },
        React.createElement(PanelCell_1.PanelCell, { mods: "u-flex u-flexAlignItemsCenter u-flexJustifyBetween" },
            React.createElement("div", { className: "u-size7of12 u-flex u-flexAlignItemsCenter u-flexAlignContentCenter" },
                React.createElement("div", { className: "expandable-group--carat" },
                    React.createElement(ListToggle_1.ListToggle, { onClick: function () { return setExpanded(!expanded); } })),
                React.createElement("div", { style: { position: 'relative' } },
                    React.createElement(react_edit_text_1.EditText, { className: "u-fontSize1x u-textBold u-spaceLeftSm", value: label, inline: true, onChange: function (e) { return onLabelChange(e.target.value); }, onBlur: function () {
                            if (onLabelBlur) {
                                onLabelBlur();
                            }
                            if (label.length === 0) {
                                setError(true);
                            }
                            else {
                                setError(false);
                            }
                        }, style: styles }),
                    error ? (React.createElement("span", { style: { position: 'absolute', top: 30, left: 8 }, className: "u-colorNegative" }, "You must enter a name for the group.")) : (''))),
            React.createElement("div", { onKeyDown: function () { }, role: "button", tabIndex: 0, className: "u-size1of12 u-flex u-flexJustifyEnd", onClick: onDelete },
                React.createElement(Icon_1.Icon, { mods: "expandable-group--trash", name: "trash", style: { width: 24, height: 24 } }))),
        expanded && children));
};
exports.default = ExpandableGroup;
